var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmotionalExhaustion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.003 30.0059C23.7366 30.0059 30.0059 23.7365 30.0059 16.0029C30.0059 8.26931 23.7366 2 16.003 2C8.26933 2 2 8.26931 2 16.0029C2 23.7365 8.26933 30.0059 16.003 30.0059Z",
    fill: "#66AB8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.0011C23.6671 2.07613 29.8591 8.31493 29.8591 15.9998C29.8591 23.6847 23.6671 29.9236 16 29.9986C21.9483 29.902 26.7477 23.6712 26.7477 15.9998C26.7477 8.32844 21.9483 2.09768 16 2.0011Z",
    fill: "#429E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54352 16.0036C9.54352 18.9545 13.9433 18.9524 13.9433 16.0036C13.9433 15.3811 13.0096 15.3811 13.0096 16.0036C12.9145 17.7075 10.5076 17.5086 10.4772 16.0036C10.4772 15.3811 9.54352 15.3811 9.54352 16.0036Z",
    fill: "#224735"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0614 16.0036C18.0614 18.9545 22.4612 18.9524 22.4612 16.0036C22.4612 15.3811 21.5275 15.3811 21.5275 16.0036C21.4324 17.7075 19.0255 17.5086 18.9951 16.0036C18.9951 15.3811 18.0614 15.3811 18.0614 16.0036Z",
    fill: "#224735"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4754 23.6315C12.004 24.0627 12.675 24.7587 13.1231 24.3033C14.7026 22.9962 17.1388 21.5352 18.9631 22.6564C19.5112 23.0111 20.0112 22.1509 19.4317 21.8502C16.9958 20.5328 14.4822 21.8793 12.4754 23.6315Z",
    fill: "#224735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionalExhaustion);
export default __webpack_public_path__ + "static/media/emotional_exhaustion.9da14916e8fe4e55db3d4437e5ca060c.svg";
export { ForwardRef as ReactComponent };